"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFooter = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const constants_1 = require("../../utils/constants");
const BronsonFooter = (props) => {
    return (React.createElement(bronson_react_1.Footer, null,
        React.createElement("div", { className: 'c-footer__module  c-footer__module--nav' },
            React.createElement("div", { className: 'o-page-wrap u-pt-large' },
                React.createElement("div", { className: 'c-footer-footnotes u-p-none' }))),
        React.createElement(bronson_react_1.Footer.ModuleMetaNav, { copyrightText: props.copyRight }, props.links &&
            props.links.length > constants_1.zero &&
            props.links.map((link, index) => (React.createElement(bronson_react_1.Footer.ModuleMetaNav.Item, { key: index, href: link.href, normalLink: true, linkProps: {
                    rel: 'noopener noreferrer',
                    target: link.target,
                } }, link.option)))),
        React.createElement(bronson_react_1.Footer.ModuleFootnotes, { footerText: props.note })));
};
exports.BronsonFooter = BronsonFooter;
